










import Vue from 'vue'

export default Vue.extend({
  name: 'QualityCellRenderer',

  computed: {
    stars (): number {
      return 5
    }
  }

})
